<template>
  <div>
    <div>
      <div class="table-container">
        <table
          cellspacing="0"
          style="
            margin-bottom: 5px;
            font-size: 15px;
            width: 100%;
            border-collapse: collapse;
          "
        >
          <tr>
            <td
              colspan="2"
              style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"
            >
              <div
                style="
                  float: left;
                  width: 50%;
                  line-height: 18px;
                  margin-top: 5px;
                "
              >
                <strong style="font-size: 25px">{{ empresa.nombrec }}</strong
                ><br />
                <small style="color: #7a7a7a; font-size: 14px"
                  >Nit: {{ empresa.nit | textnumber()
                  }}{{ empresa.nit | dverif() }}</small
                ><br />
                <span style="color: #7a7a7a; font-size: 12px">{{
                  empresa.nombre
                }}</span>

                <br />
                <span style="font-size: 14px"
                  >{{ empresa.ciudad }} {{ empresa.direccion }} Tel{{
                    empresa.telefono
                  }}</span
                >
              </div>
              <div style="float: left; width: 50%">
                <img :src="data.comprobante.urlimg" alt="" />
              </div>
            </td>
            <td
              colspan="2"
              style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"
            >
              <div class="has-text-centered">
                <strong style="font-size: 15px">{{
                  data.comprobante.titulo
                    ? data.comprobante.titulo
                    : data.comprobante.nombre
                }}</strong>
              </div>
              <div class="has-text-right">
                <strong class="fontMono" style="font-size: 30px"
                  >{{ data.comprobante.prefijo }} {{ total.documento }}</strong
                >
              </div>
            </td>
          </tr>
          <tr>
            <td
              colspan="4"
              style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"
            >
              <span class="fontMono">{{ data.comprobante.resolucion }}</span>
            </td>
          </tr>
          <tr>
            <td
              colspan="2"
              style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"
            >
              <span>
                <strong>Cliente:</strong>
                <span class="fontMono">{{ cliente.nombre }}</span>

                <strong>Nit:</strong>
                <span class="fontMono">{{ cliente.codigo }}</span>

                <br />
                <strong>{{ cliente.direccion ? "Dirección: " : "" }}</strong>
                <span class="fontMono"
                  >{{ cliente.ciudad }} {{ cliente.direccion }}</span
                >

                <strong>{{ cliente.telefono ? "Teléfono: " : "" }}</strong>
                <span class="fontMono">{{ cliente.telefono }}</span>

                <strong>{{ cliente.correo ? "Correo: " : "" }}</strong>
                <span class="fontMono">{{ cliente.correo }}</span>
              </span>
            </td>
            <td
              style="width: 110px; text-align:right; border: 1px solid #dbdbdb; !important; padding: 5px !important;"
            >
              <strong>Fecha</strong>
              <br />
              <span class="fontMono">{{ total.fecha | date() }}</span>
            </td>
            <td
              style="width: 110px; text-align:right; border: 1px solid #dbdbdb; !important; padding: 5px !important;"
            >
              <strong>Vencimiento</strong>
              <br />
              <span class="fontMono">{{ vencimiento | date() }}</span>
            </td>
          </tr>
          <tr v-if="registros[0] && registros[0].datosFactura">
            <td
              colspan="4"
              style="text-align:right; border: 1px solid #dbdbdb; !important; padding: 5px !important;"
            >
              <span>{{
                registros[0].datosFactura ? registros[0].datosFactura.texto : ""
              }}</span>
            </td>
          </tr>
        </table>
        <table
          cellspacing="0"
          style="margin-bottom: 5px; font-size: 15px; border: 1px solid #dbdbdb; !important; padding: 5px !important; width:100%; border-collapse: collapse;"
        >
          <tr style="background-color: #f5f5f5">
            <th
              style="width: 28px; border: 1px solid #dbdbdb; !important; padding: 5px !important;"
            >
              #
            </th>
            <th
              style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"
            >
              Descripción
            </th>
            <th
              style="text-align:right; border: 1px solid #dbdbdb; !important; padding: 5px !important;"
            >
              Valor
            </th>
          </tr>
          <tr v-for="(registro, index) in registros" :key="index">
            <td
              class="fontMono"
              style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"
            >
              {{ index + 1 }}
            </td>
            <td
              style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"
            >
              {{ registro.descripcion }}
            </td>
            <td
              class="fontMono"
              style="text-align:right; border: 1px solid #dbdbdb; !important; padding: 5px !important;"
            >
              {{ total.tipo == registro.tipo ? "-" : ""
              }}{{ registro.valor | number(2) }}
            </td>
          </tr>
          <tr>
            <td
              style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"
            >
              <strong class="fontMono">S</strong>
            </td>
            <td
              style="font-size: 17px; border: 1px solid #dbdbdb; !important; padding: 5px !important;"
            >
              <strong>Subtotal</strong>
            </td>
            <td
              style="font-size: 17px; text-align:right; border: 1px solid #dbdbdb; !important; padding: 5px !important;"
            >
              <strong class="fontMono">${{ subtotal | number(2) }}</strong>
            </td>
          </tr>
          <tr>
            <td
              class="fontMono"
              style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"
            >
              I
            </td>
            <td
              style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"
            >
              Iva
            </td>
            <td
              class="fontMono"
              style="text-align:right; border: 1px solid #dbdbdb; !important; padding: 5px !important;"
            >
              ${{ iva | number(2) }}
            </td>
          </tr>
          <tr style="background-color: #f5f5f5">
            <td
              style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"
            >
              <strong class="fontMono">T</strong>
            </td>
            <td
              style="font-size: 20px; border: 1px solid #dbdbdb; !important; padding: 5px !important;"
            >
              <strong
                >Total
                {{
                  data.comprobante.titulo
                    ? data.comprobante.titulo
                    : data.comprobante.nombre
                }}</strong
              >
            </td>
            <td
              style="font-size: 20px;text-align:right; border: 1px solid #dbdbdb; !important; padding: 5px !important;"
            >
              <strong class="fontMono">
                <span style="margin-right: 5px" v-show="data.comprobante.cop"
                  >COP</span
                >
                ${{ total.valor | number(2) }}
              </strong>
            </td>
          </tr>
          <tr v-if="data.comprobante.letras">
            <td
              colspan="3"
              style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"
            >
              {{ total.valor | nletras() }}
            </td>
          </tr>
          <tr>
            <td
              colspan="3"
              style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"
            >
              <small>{{ data.comprobante.small }}</small>
              <br />
              <strong style="font-size: 13px">{{
                data.comprobante.negrita
              }}</strong>
            </td>
          </tr>
        </table>
        <table
          cellspacing="0"
          style="margin-bottom: 5px; font-size: 15px; border: 1px solid #dbdbdb; !important; padding: 5px !important; width:100%; border-collapse: collapse;"
        >
          <tr>
            <td
              style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"
            >
              {{ data.comprobante.t1 }}
              <br />
              <br />
              <br />
            </td>
            <td
              style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"
            >
              {{ data.comprobante.t2 }}
            </td>
          </tr>
          <tr>
            <td
              colspan="2"
              style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"
            >
              {{ data.comprobante.mensaje }}
            </td>
          </tr>
        </table>
        <div style="text-align: center">
          <strong>{{ cufe }}</strong>
        </div>
        <canvas id="canvas"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
const QRCode = require("qrcode");
export default {
  props: {
    data: Object,
    total: Object,
    registros: Array,
    iva: Number,
    cliente: Object,
    subtotal: Number,
    vencimiento: Date,
    cufe: String,
  },
  methods: {
    createqr() {
      const canvas = document.getElementById("canvas");
      QRCode.toCanvas(
        canvas,
        `https://catalogo-vpfe.dian.gov.co/document/searchqr?documentkey=${this.cufe}`,
        { errorCorrectionLevel: "L" },
        function (error) {
          if (error) console.error(error);
          console.log("success!");
        }
      );
    },
  },
  mounted() {
    this.createqr();
  },
  computed: {
    ...mapState(["empresa"]),
  },
};
</script>


// WEBPACK FOOTER //
// src/components/prints/Printcomercialfacturaelectronica.vue